<template>
  <div>
    <el-form label-width="50px">
      <el-row :gutter="10"
              style="padding-bottom:10px">
        <el-col :lg="6"
                :md="12"
                v-if="home_id == 1 "
                :sm="12"
                :xl="6"
                :xs="24">
          <el-form-item label="学校:">
            <el-select v-model="school_id"
                       filterable
                       clearable
                       style="width:100%"
                       placeholder="选择学校">
              <el-option v-for="item in schoolList"
                         :key="item.school_id"
                         :label="item.school_name"
                         :value="item.school_id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="6"
                :md="12"
                :sm="12"
                :xl="6"
                :xs="24">
          <el-form-item label="届:">
            <el-select v-model="form.graduated_id"
                       style="width:100%"
                       filterable
                       @change="jieChange"
                       placeholder="选择届">
              <el-option v-for="item in jieList"
                         :key="item.graduated_id"
                         :label="item.year_desc"
                         :value="item.graduated_id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :lg="6"
                :md="12"
                :sm="12"
                :xl="6"
                :xs="24">
          <el-form-item label="年级:">
            <el-select style="width:100%"
                       v-model="form.grade_id"
                       clearable
                       @change="gradeChange"
                       placeholder="选择年级">
              <el-option v-for="item in gradeList"
                         :key="item.grade_id"
                         :label="item.grade_name"
                         :value="item.grade_id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :lg="6"
                :md="12"
                :sm="12"
                :xl="6"
                :xs="24">
          <el-form-item label="科目:">
            <el-select style="width:100%"
                       :clearable="school_id  == 1"
                       v-model="form.subject_id"
                       placeholder="选择科目">
              <el-option v-for="(item,index) in subjectList"
                         :key="index"
                         :label="item.subject_name"
                         :value="item.subject_id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="6"
                :md="12"
                :sm="12"
                :xl="6"
                :xs="24">
          <el-form-item label="班级:">
            <el-select v-model="form.class_id"
                       style="width:100%"
                       filterable
                       multiple
                       @change="classChange"
                       placeholder="选择班级">
              <el-option v-for="item in classList"
                         :key="item.id"
                         :label="item.class_name"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="6"
                :md="12"
                :sm="12"
                :xl="6"
                :xs="24">
          <el-form-item label="分组:">
            <el-select v-model="form.organize_ids  "
                       style="width:100%"
                       clearable
                       filterable
                       multiple
                       placeholder="请选择">
              <el-option v-for="item in groupList"
                         :key="item.organize_id"
                         :label="item.name"
                         :value="item.organize_id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :lg="6"
                :md="12"
                :sm="12"
                :xl="6"
                :xs="24">
          <el-form-item label="开始时间:"
                        label-width="90px">
            <el-date-picker v-model="form.begin_time"
                            style="width:100%"
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="开始时间" />
          </el-form-item>
        </el-col>
        <el-col :lg="6"
                :md="12"
                :sm="12"
                :xl="6"
                :xs="24">

          <el-form-item label="结束时间:"
                        label-width="90px">
            <el-date-picker v-model="form.end_time"
                            style="width:100%"
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="结束时间" />
          </el-form-item>
        </el-col>

        <el-col :span="15">
          <el-button type="primary"
                     @click="initData">查询</el-button>
        </el-col>
      </el-row>
    </el-form>
    <Table ref="TablesRef"
           :tableData="tableData" />
  </div>
</template>

<script>
import testVue from '../../test.vue'
import { nowDateTime, frontDay } from '@/utils/date.js'
export default {
  name: 'weaknessStatic',
  data () {
    return {
      page: 1,
      size: 10,
      totalElements: 0,
      subjectList: [],
      tableData: [],
      classList: [],
      jieList: [],
      gradeList: [],
      schoolList: [],
      groupList: [],
      school_id: '',
      form: {
        graduated_id: '',
        class_id: '',
        subject_id: '',
        grade_id: '',
        special_class_ids: undefined,
        begin_time: frontDay(7),
        end_time: nowDateTime()
      },
      home_id: 0,
      tableData: [],
      pageName: 'cz_student_weakness_admin',
      tableColumns: [
        // { prop: 'knowledge_id', align: 'center', label: '知识点ID', width: '', showToopic: false },
        { prop: 'knowledge_desc', align: 'center', label: '考点名称', width: '', showToopic: true },
        { prop: 'count', align: 'center', label: '所有学生做题次数', width: '', showToopic: false },
        { prop: 'score', align: 'center', label: '所有学生总得分率', width: '', showToopic: false },
        {
          prop: 'd', align: 'center', label: '操作', width: '', type: 'img', btns: [
            { content: '考点详细数据', type: 'look', event: 'toDetail' },
            { content: '二级考点', type: 'look', event: 'secondTestSiteFn'  ,isPd: true },
            { content: '三级考点', type: 'look', event: 'thirdTestSiteFn', isPd: true },
          ]
        },
      ]
    }
  },
  mounted () {
    this.$http({
      url: '/api/v1/public/get_record',
      method: 'get',
      params: {
        module_id: 33
      }
    }).then(res => {
      if (res.data && res.data.list.length != 0) {
        this.is_detailed = JSON.parse(window.localStorage.getItem('userInfo')).is_detailed
        let form = res.data.list
        this.form = {
          ...form,
        }

      }
    })
    this.setTablesColums()
    this.getJie()

    this.getRole()
    this.getGroupList()


  },
  methods: {
    getBtnStatus (opItem, row) {
      // 是否显示【二级考点】按钮
      if (opItem.event == "secondTestSiteFn") {
        if (row['has_check_point2']) {
          return true
        } else {
          return false
        }
      }
      if (opItem.event == "thirdTestSiteFn") {
        if (row['has_check_point3']) {
          return true
        } else {
          return false
        }
      }
    },
    getGroupList () {
      this.$http({
        url: '/api/v1/organize/lst',
        method: 'get',
      }).then(res => {
        this.groupList = res.data.list
      })

    },
    getRole () {
      this.$http({
        url: '/api/v1/public/homepage_role',
        method: 'get',
      }).then(res => {
        this.home_id = res.data.home_id
      })
    },
    schoolChange () {
      this.getClassList()
    },
    getSchoolList () {
      this.$http({
        url: '/api/v1/main/get_user_school',
        method: 'get'
      }).then(res => {
        this.schoolList = res.data.list

        if (this.home_id == 1) {
          this.school_id = this.schoolList[0].school_id
        } else {
          this.school_id = JSON.parse(window.localStorage.getItem('userInfo')).edu_school_id
        }

      })
    },
    clearClass () {
      this.tableData = []
    },
    getJie () {
      this.$http({
        url: '/api/v1/public/graduated_lst',
        method: 'get'
      }).then(res => {
        this.jieList = Object.values(res.data)
        // this.form.graduated_id = this.jieList[0].graduated_id
        this.getSchoolList()
        this.getGradeList()
      })
    },
    getClassList () {
      // this.$http({
      //   url: '/api/v1/special/get_class',
      //   method: 'get',
      //   params: {
      //     graduated_id: this.form.graduated_id,
      //     school_id: this.school_id
      //   }
      // }).then(res => {
      //   this.classList = res.data.list
      //   // this.form.class_id = res.data.list[0].id || ''
      //   this.classChange()
      // })

      this.$http({
        url: '/api/v1/special/tc_lead_class',
        method: 'get',
        params: {
          all_class: 1,
          graduated_id: this.form.graduated_id,
          grade_id: this.form.grade_id,
          school_id: this.school_id
        }
      }).then(res => {
        this.classList = res.data
        this.classChange()
      })
    },
    setTablesColums () {
      this.$refs.TablesRef.pageName = this.pageName
      this.$refs.TablesRef.setColumns(this.tableColumns)
    },
    initData () {
      if (this.school_id != 1 && (!this.form.graduated_id  || !this.form.grade_id || !this.form.subject_id)) {
        return this.$message.warning('请选择届，科目，年级')
      }
      this.form.level = 1
      let form = {
        ...this.form,
        edu_school_id:this.school_id
      }
      form.edu_class_id = form.class_id
      delete form.class_id
      this.$http({
        url: '/api/v1/combination/weak_list',
        method: 'get',
        params: form
      }).then(res => {
        this.tableData = res.data.list

        console.log(res.data.list);
        this.totalElements = res.data.list
      })
      this.form.module_id = 33
      this.$http({
        url: '/api/v1/public/set_record',
        method: 'post',
        data: this.form
      }).then(res => {
        // this.$notify({
        //   title: '提示',
        //   message: '操作成功!',
        //   type: 'success'
        // });
      })
    },
    getSLsubjectList () {
      this.$http({
        url: '/api/v1/public/class_grade_subject',
        method: 'get',
        params: {
          grade_id: this.form.grade_id,
        }
      }).then(res => {
        this.subjectList = res.data
        // this.form.subject_id = this.subjectList[0].subject_id

      })
    },
    // 查看二级考点 
    secondTestSiteFn (row) {
      let form = {

        class_id: row.class_id,
        edu_school_id: this.school_id,
        knowledge_parent_id: row.knowledge_id,
        knowledge_desc: row.knowledge_desc,
        ...this.form
      }
      const queryInfo = encodeURIComponent(JSON.stringify(form))
      this.$router.push({
        path: "/studentCondition/weakness/secondTestSite",
        query: {
          queryInfo: queryInfo
        }
      })

    },
    // 查看三级考点 
    thirdTestSiteFn (row) {
      this.form.level = 3
      let form = {
        edu_school_id: this.school_id,
        class_id: row.class_id,
        knowledge_parent_id: row.knowledge_id,
        knowledge_desc: row.knowledge_desc,

        ...this.form

      }
      const queryInfo = encodeURIComponent(JSON.stringify(form))
      this.$router.push({
        path: "/studentCondition/weakness/thirdTestSite",
        query: {
          queryInfo: queryInfo
        }
      })

    },

    toDetail (row) {
      let form = {
        knowledge_id: row.knowledge_id,
        // class_id: this.form.class_id
        edu_school_id: this.school_id,
        ...this.form
      }
      this.$router.push('/studentCondition/weakness/detail?form=' + JSON.stringify(form))
    },
    getGradeList () {
      this.$http({
        url: '/api/v1/school/select_grade',
        method: 'get'
      }).then(res => {
        this.gradeList = res.data.list
        if (this.form.grade_id) {
          this.getSLsubjectList()
        }

        this.getClassList()
      })
    },
    subjectChange () {
      this.form.grade_id = ''
      if (this.school_id != 1 && this.form.subject_id) {
        let row = this.subjectList.find(item => item.subject_id == this.form.subject_id)
        if (row) {
          this.form.grade_id = row.grade_id
        }
      }

    },
    gradeChange () {
      // this.initData()
      if (this.form.grade_id) {
          this.getSLsubjectList()
        }
      this.getClassList()
      this.$set(this.form, 'class_id', '')
    },
    classChange () {


    },
    jieChange () {
      this.$set(this.form, 'subject_id', '')
      this.$set(this.form, 'grade_id', '')
      this.$set(this.form, 'class_id', '')
      this.subjectList = []


    }
  }
}
</script>

<style lang="scss" scoped>
</style>
